import { SecureStorage } from '@aparajita/capacitor-secure-storage'
import { isNative } from './platform'

const KEY = 'hugo.session'

let cached: string | null | undefined

/**
 * Bearer token for the native app, kept in the iOS Keychain / Android Keystore. The web app uses
 * an httpOnly cookie instead and never stores a token in JavaScript.
 */
export const tokenStore = {
  async get(): Promise<string | null> {
    if (!isNative) return null
    if (cached !== undefined) return cached
    const value = await SecureStorage.get(KEY).catch(() => null)
    cached = typeof value === 'string' && value !== '' ? value : null
    return cached
  },
  async set(token: string): Promise<void> {
    if (!isNative) return
    cached = token
    await SecureStorage.set(KEY, token, false, false)
  },
  async clear(): Promise<void> {
    cached = null
    if (!isNative) return
    await SecureStorage.remove(KEY).catch(() => false)
  },
}
